"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableFunnelChart_1 = require("./PluggableFunnelChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var FunnelChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(FunnelChartDescriptor, _super);
    function FunnelChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FunnelChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableFunnelChart_1.PluggableFunnelChart(params); };
    };
    return FunnelChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.FunnelChartDescriptor = FunnelChartDescriptor;
//# sourceMappingURL=FunnelChartDescriptor.js.map